'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { signOutFromBaza } from '@/app/baza/_components/Navbar/_helpers/sign-out-from-baza';
type NavbarMobileAuthSectionProps = {
  userLogged: boolean;
  hrefRedirect: string;
  onNavigate?: () => void;
};
export function NavbarMobileAuthSection(t0) {
  const $ = _c(11);
  const {
    userLogged,
    hrefRedirect,
    onNavigate
  } = t0;
  if (userLogged) {
    let t1;
    if ($[0] !== onNavigate) {
      t1 = <Button color="destructive" className="w-full" onClick={() => {
        onNavigate?.();
        signOutFromBaza();
      }}>Wyloguj się</Button>;
      $[0] = onNavigate;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = `/auth/register?${hrefRedirect}`;
  let t2;
  if ($[2] !== onNavigate || $[3] !== t1) {
    t2 = <Button href={t1} className="w-full" onClick={onNavigate}>Zarejestruj się</Button>;
    $[2] = onNavigate;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `/auth/login?${hrefRedirect}`;
  let t4;
  if ($[5] !== onNavigate || $[6] !== t3) {
    t4 = <Button href={t3} outline={true} className="w-full" onClick={onNavigate}>Zaloguj się</Button>;
    $[5] = onNavigate;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="space-y-3">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}